
import locales from "./../../../content.json"

export const loaderSteps = [
    {
        min: 0,
        max: 17,
        title: locales[window.userLang].responses,
    },
    {
        min: 18,
        max: 33,
        title: locales[window.userLang].lifestyle,
    },
    {
        min: 34,
        max: 50,
        title: locales[window.userLang].metabolic_age,
    },
    {
        min: 51,
        max: 66,
        title: locales[window.userLang].your_needs,
    },
    {
        min: 67,
        max: 83,
        title: locales[window.userLang].suitable_recipes,
    },
    {
        min: 84,
        max: 100,
        title: locales[window.userLang].plan_is_ready,
    },
]